import * as VisaForm from './components/VisaForm.css';

export default {
	VisaForm
};
